// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1Cr9-","detailsBorder":"styles_detailsBorder__KFul6"};